import axiosInstance from './axiosConfig'
const store = require('./store').default

const get = async (route, params = {}) => {
  const result = await axiosInstance
    .get(route, params)
    .then((res) => {
      return { ...res.data, httpStatus: res.status }
    })
    .catch((err) => {
      return { error: true, ...err.response, status: err.response?.status }
    })

  return result
}

const search = async (route, objectParams) => {
  const result = await axiosInstance
    .get(route, { params: objectParams })
    .then((res) => {
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      return { error: true, ...err.response, status: err.response.status }
    })
  return result
}

const insert = async (route, object, itemMessage) => {
  let headers = {}
  for (let key in object) {
    if (object[key] instanceof File) {
      headers = { 'Content-Type': 'multipart/form-data' }
    }
  }
  const result = await axiosInstance
    .post(route, object, {
      headers: headers,
    })
    .then((res) => {
      store.dispatch('setSuccess', {
        message: `Sucesso ao cadastrar ${itemMessage}!`,
      })
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      store.dispatch('setError', {
        message: `Erro ao cadastrar ${itemMessage}!`,
      })

      return { error: true, ...err.response, status: err.response.status }
    })
  return result
}

const put = async (route, object, itemMessage) => {
  const result = await axiosInstance
    .put(route, object)
    .then((res) => {
      if (itemMessage) {
        store.dispatch('setSuccess', {message: `Sucesso ao salvar ${itemMessage}!`})
      }
      return {...res.data, status: res.status}
    })
    .catch((err) => {
      if (itemMessage) {
        store.dispatch('setError', {message: `Erro ao salvar ${itemMessage}!`})
      }
      return {error: true, ...err.response, status: err.response?.status}
    })
  return result
}

const update = async (route, id, object, itemMessage) => {
  const result = await axiosInstance
    .patch(`/${route}/${id}`, object)
    .then((res) => {
      if (itemMessage) {
        store.dispatch('setSuccess', {
          message: `Sucesso ao atualizar ${itemMessage}!`,
        })
      }
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      store.dispatch('setError', {
        message: `Erro ao atualizar ${itemMessage}!`,
      })
      return { error: true, ...err.response, status: err.response?.status }
    })
  return result
}

const remove = async (route, id, itemMessage) => {
  const result = await axiosInstance
    .delete(`/${route}/${id}`)
    .then((res) => {
      store.dispatch('setSuccess', {
        message: `Sucesso ao remover ${itemMessage}!`,
      })

      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      console.log(err)

      store.dispatch('setError', {
        message: `Erro ao remover ${itemMessage}!`,
      })

      return { error: true, ...err.response, status: err.response.status }
    })
  return result
}

const batchRemove = async (route, itemsArray, itemMessage) => {
  try {
    const result = await axiosInstance
      .delete(`/${route}/batch-remove`, { data: { items: itemsArray } })
      .then((res) => {
        store.dispatch('setSuccess', {
          message: `Sucesso ao remover ${itemMessage}!`,
        })

        return { ...res.data, status: res.status }
      })
      .catch((err) => {
        console.log(err)

        store.dispatch('setError', {
          message: `Erro ao remover ${itemMessage}!`,
        })

        return { error: true, ...err.response.data, status: err.response.status }
      })

    return result
  } catch (error) {
    console.log(error)
    store.dispatch('setError', {
      message: `Erro ao remover ${itemMessage}!`,
    })

    return { error: true, message: error.message, status: 500 }
  }
}

const validateCurrentPassword = async (route, object) => {
  const result = await axiosInstance
    .post(route, object)
    .then((res) => {
      return res
    })
    .catch((err) => {
      return err
    })
  return result
}

const insertFile = async (route, object) => {
  const formData = new FormData()

  Object.keys(object).forEach((el) => {
    const value = object[el]
    if (Array.isArray(value)) {
      const hasOnlyFiles = value.length > 0 && value.every((item) => item instanceof File || item instanceof Blob)

      if (hasOnlyFiles) {
        value.forEach((file) => {
          formData.append(el === 'files' ? 'file' : el, file)
        })
      } else {
        formData.append(el, JSON.stringify(value))
      }
    } else if (value !== null && value !== undefined && typeof value === 'object' && !(value instanceof File) && !(value instanceof Blob)) {
      formData.append(el, JSON.stringify(value))
    } else if (value !== null && value !== undefined) {
      formData.append(el, value)
    }
  })

  const result = await axiosInstance
    .post(route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      store.dispatch('setSuccess', {
        message: `Sucesso ao enviar arquivo!`,
      })
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      store.dispatch('setError', {
        message: `Erro ao enviar arquivo!`,
      })
      return { error: true, ...err.response, status: err.response.status }
    })
  return result
}

const getFile = async (
  params = {},
  fileName = 'download',
  headers = {},
  route = null,
  routeName = null,
  content,
  includeDeleted,
) => {
  const endpoint = route || routeName
  if (!endpoint) {
    return { error: true, message: 'Rota de exportação não definida.', status: 400 }
  }

  const queryParams = { ...(params || {}) }
  if (content !== undefined && content !== null) queryParams.content = content
  if (includeDeleted !== undefined && includeDeleted !== null) queryParams.includeDeleted = includeDeleted

  try {
    const response = await axiosInstance.get(endpoint, {
      params: queryParams,
      headers: headers || {},
      responseType: 'blob',
    })

    const blob = response.data instanceof Blob
      ? response.data
      : new Blob([response.data], { type: response.headers?.['content-type'] || 'application/octet-stream' })
    const objectUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = objectUrl
    link.download = fileName || 'download'
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(objectUrl)

    return { status: response.status, data: blob, fileName: link.download }
  } catch (err) {
    return { error: true, ...err.response, status: err.response?.status || 500 }
  }
}

export { get, search, update, remove, batchRemove, insert, put, validateCurrentPassword, insertFile, getFile }
